  (function () {
    function pick(btn) {
      var L =
        (window.Rivo &&
          window.Rivo.loy_config &&
          window.Rivo.loy_config.membership_tiers) || [];
      var t = L.find(function (i) { return i.price > 0; });
      var href = btn.getAttribute("href") || "";
      var m = href.match(/membership-add-to-cart-(\d+)/);
      var id = (m && m[1]) || btn.dataset.membershipTierId;
      if (id) {
        t = L.find(function (i) {
          return String(i.id) === String(id);
        }) || t;
      }
      return t;
    }
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var sel = 'a[href*="membership-add-to-cart"]';
      var btn = e.target.closest(sel) ||
        e.target.closest(".rivo-membership-add-to-cart");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var t = pick(btn);
      var fn = window.addRivoSellingPlanToCart;
      if (t && typeof fn === "function") {
        fn(t.variant_id, t.selling_plan_id,
          t.gwp_reward_enabled ? t.gwp_variant_id : null);
      }
    }, true);
  })();